import { Query } from '@apollo/client/react/components';
import * as React from 'react';
import { ApolloError } from '@apollo/client';

import GROUP_BY_CODE_QUERY from 'groups/queries/LoadByGroupCodeQuery.gql';
import {
  LoadGroupByCode,
  LoadGroupByCode_classes,
} from 'groups/queries/__generated__/LoadGroupByCode';

export type Props = {
  groupCode: string;
  children: (props: {
    group?: LoadGroupByCode_classes;
    loading: boolean;
    error?: ApolloError;
  }) => JSX.Element | null;
};

export default function GroupByCodeFetcher(props: Props) {
  return (
    <Query<LoadGroupByCode> query={GROUP_BY_CODE_QUERY} variables={{ code: `@${props.groupCode}` }}>
      {({ loading, error, data }) => {
        const group = (data && data.classes && data.classes[0]) || undefined;
        return props.children({ group, loading, error });
      }}
    </Query>
  );
}
